import { Container, Row, Col } from "react-bootstrap";
import {
    LEGAL_INFO_AND_WEBSITE_USAGE_URL,
    PL_LOGO_BLACK_URL,
    PRIVACY_POLICIES_URL,
    HOME_URL_PATH
} from "../constants";

export const Header = () => {
    return (
        <Container className="riaheader">
            <Row>
                <Col className="riawhite">
                    <div id="logo">
                        <a href={HOME_URL_PATH}>
                            <img
                                alt="Pacific Life Logo"
                                src={PL_LOGO_BLACK_URL}
                            />
                        </a>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export const Footer = () => {
    return (
        <Container className="footer-ria">
            <Row>
                <div id="footer">
                    <p id="cgf" className="link-underline">
                        © {new Date().getFullYear()} Pacific Life Insurance
                        Company{" "}
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={PRIVACY_POLICIES_URL}
                        >
                            Privacy Policy
                        </a>{" "}
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={LEGAL_INFO_AND_WEBSITE_USAGE_URL}
                        >
                            Terms of Usage
                        </a>
                    </p>
                </div>
            </Row>
        </Container>
    );
};

export const Disclaimer = () => {
    return (
        <div className="disclaimer">
            <span className="link-underline">
                All fields are required. Registration information will not be
                shared. By creating an account you agree to Pacific Life’s{" "}
                <a href={LEGAL_INFO_AND_WEBSITE_USAGE_URL}>
                    Terms & Conditions
                </a>
            </span>
        </div>
    );
};

export const DisclaimerPolicyOwner = () => {
    return (
        <div className="disclaimer">
            <span className="link-underline">
                All fields are required except when noted.
            </span>
        </div>
    );
};

export const DisclaimerContractedFindUser = () => {
    return (
        <div className="disclaimerFindUser">
            <span className="link-underline-red">
                Attention: If you are a non-contracted user (Delegate or Back office), 
                you must contact the Pacific Life support team to recover your Username: (800) 800-7681.
                <br />
            </span>
            <span style={{ float: "right" }}>FPW-PR-UNK0726a</span>
        </div>
    );
};

export const DisclaimerContractedUpdateUser = () => {
    return (
        <div className="disclaimerFindUser">
            <span className="link-underline-red">
                Attention: If you are a non-contracted user (Delegate or Back office), 
                you must contact the Pacific Life support team to recover your Username: (800) 800-7681.
                <br />
            </span>
            <span style={{ float: "right" }}>FPW-PR-D0726a</span>
        </div>
    );
};

export const DisclaimerNonContractedFindUser = () => {
    return (
        <div className="disclaimerFindUser">
            <span className="link-underline">
                Need help? Contact the Pacific Life support team for assistance: (800) 800-7681.
                <br />
            </span>
            <span style={{ float: "right" }}>FPW-PR-UNK0726a</span>
        </div>
    );
};

export const DisclaimerNonContractedUpdateUser = () => {
    return (
        <div className="disclaimerFindUser">
            <span className="link-underline">
                Need help? Contact the Pacific Life support team for assistance: (800) 800-7681.
                <br />
            </span>
            <span style={{ float: "right" }}>FPW-PR-D0726a</span>
        </div>
    );
};
